<template lang="pug">
  form(@submit.prevent='submit')
    .row
      p.col.s12.title.medium Create New Inventory
    .row
      .col.s12.input-field
        input#name(type='text' v-model='name' required)
        label(for='name') Name
    .row
      .col.s12.right-align
        button.btn Add
</template>
<script>
export default {
  props: ['onAddSuccess', 'onAddFailed'],
  data () {
    return {
      name: null
    }
  },
  mounted () {
    this.$M.updateTextFields()
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        this.$http.post(`${this.$config.API_URL}/suppliers/${this.supplier.id}/inventories`, {
          name: this.name
        }, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).then(result => {
          this.onAddSuccess(result.data)
        })
      }).catch(err => {
        this.onAddFailed(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal-create-inventory.vue